import { h, FunctionalComponent } from '@stencil/core';

interface HeadingTagProps {
  level: string;
  id?: string;
  cssClass?: string;
  additionalProps?: { [key: string]: string };
}

export const HeadingTag: FunctionalComponent<HeadingTagProps> = ({ level, id, cssClass, additionalProps }, children) => {
  const Tag = level;

  return <Tag id={id} className={cssClass} {...additionalProps} innerHTML={children}></Tag>;
};
